// extracted by mini-css-extract-plugin
export default {"h1":"Contact_h1__pgBt+","contact":"Contact_contact__pXG3B"};